import { Component,  Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BudgetSectionGridData, PaymentGridData } from '../../helpers/grid-helpers';
import { Budget, BudgetSection } from '../../store/reselectors/budget.data';
import { getGridDataFromSection, scheduleToScheduleGridData } from '../../store/reselectors/budget.reselector.helpers';
import { BigDialogWrapperComponent } from 'src/app/components/wrappers/big-dialog-wrapper.component';
import { BudgetSectionComponent } from './budget-section.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'updates-available',
    template: `
<wide-dialog-wrapper
  [backgroundColor]="'#EA9999'"
  [dialogTitle]="'Linked Costs Section Updates'"
  [successLabel]="'Update Link'"
  [midLeftLabel]="'Cancel'"
  [midRightLabel]="update ? 'View Previous' : 'View Update'"
  [disabled]="!update"
  [delete]="false"
  (onMidRight)="view(update)"
  (onMidLeft)="dialogRef.close()"
  (onSubmit)="dialogRef.close(true)"
>
  <budget-section
    [section]="section"
    [isRevenue]="data.isRevenue"
    [budgetCurrency]="data.budget.currency"
    [gridData]="gridData"
    [scheduleGridData]="gridSchedule"
    [readOnly]="true"
    [showAllColumns]="true"
  ></budget-section>
</wide-dialog-wrapper>
`,
    styles: [`
  budget-section { padding: 40px; }
  ::ng-deep wide-dialog-wrapper .mat-button.mat-primary { margin: 0 20px 0 0 !important; }
`],
    standalone: true,
    imports: [BigDialogWrapperComponent, BudgetSectionComponent, CommonModule],
})
export class UpdatesAvailableDialogComponent {
  section: BudgetSection
  gridData: BudgetSectionGridData[]
  gridSchedule: PaymentGridData[]

  update = true

  constructor(public dialogRef: MatDialogRef<UpdatesAvailableDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: UpdatesAvailableData) {
    this.setSection()
    console.log({ data })
  }

  setSection () {
    this.section = this.update ? this.data.updatedSection : this.data.previousSection
    this.gridData = getGridDataFromSection(this.section, this.data.budget.currency)
    if (this.data.showSchedules) this.gridSchedule = scheduleToScheduleGridData(this.section.schedule, this.section.total)

  }

  view(previous: boolean) {
    if (previous) this.update = false
    else this.update = true
    this.setSection()
  }

}


export interface UpdatesAvailableData {
  previousSection: BudgetSection
  updatedSection: BudgetSection
  budget: Budget
  showSchedules?: boolean
  isRevenue: boolean
}